import React from "react";
import { NavLink } from "react-router-dom"; // Add NavLink here
import { Card, CardBody, Row, Col } from "reactstrap";
import content from 'content.json'; // Importing the JSON file
import HtmlContent from "components/Custom/htmlContent";


function Faq() {
  return (
    <>
      <div className="content">
        <Row>
          <Col md="10">
            <Card>
              <CardBody>
                <div className="typography-line">
                  <h1>Frequently Asked Questions (FAQ)</h1>

                  <h3>1. Are you affiliated with ADE (Amsterdam Dance Event)?</h3>
                  <p>
                    No, {content.brandname} has no affiliation with ADE (Amsterdam Dance Event) whatsoever. 
                    This website is completely independent and is not officially connected to, endorsed by, or associated with ADE in any way.
                  </p>
                  <br />

                  <h3>2. How do you handle sensitive data?</h3>
                  <p>
                    We use factual event data including event dates and artist information. We do not consider this information to be sensitive data, 
                    as it consists of publicly available factual information about events and performances. However, to ensure complete compliance, 
                    we have a pending question with ADE to get this verified and confirmed.
                  </p>
                  <br />

                  <h3>3. Are you affiliated with {content.application}?</h3>
                  <p>
                    No, {content.brandname} is not affiliated with {content.application} in any way. 
                    This website is an independent add-on tool that provides enhanced insights into your {content.application} {content.entries}. 
                    It is completely independent and is by no means officially connected to or endorsed by {content.application}.
                  </p>
                  <br />

                  <h3>4. Why do I need to log in with Google?</h3>
                  <p>
                    We use Google login because it provides a secure and reliable way to authenticate users. This also allows us to avoid managing passwords, password resets, and other account maintenance tasks directly, as Google manages these for us.
                  </p>
                  <br />

                  <h3>5. Why did you create {content.brandname}?</h3>
                  <p>
                    I created {content.brandname} to help find the right events when there are hundreds of artists performing. With hundreds of artists on my techno playlists, it became challenging to identify which events would be most relevant to my music taste. This tool helps analyze my {content.entries} and provides insights to make better event choices by showing which artists from my playlists are performing at specific events.
                  </p>
                  <br />

                  <h3>6. Can I request new features?</h3>
                  <p>
                    Yes! I'm always open to feedback and new feature ideas. You can request features or report any issues by visiting our GitHub issues page at:
                    <HtmlContent html={content.issue_url} />
                  </p>
                  <br />

                  <h3>7. How does {content.brandname} handle my privacy?</h3>
                  <p>
                    We take your privacy very seriously. We only collect essential information to provide our services, and all data handling follows strict guidelines. For full details, please refer to our <NavLink to="/admin/Privacy">Privacy Policy</NavLink>.
                  </p>
                  <br />

                  <h3>8. Does {content.brandname} use cookies?</h3>
                  <p>
                    Yes, we use a functional cookie that stores your session login information for 3 hours. We do not use marketing or analytics cookies. For more information, please see our <NavLink to="/admin/Cookies">Cookie Policy</NavLink>.
                  </p>
                  <br />

                  <h3>9. How can I request removal of my personal information?</h3>
                  <p>
                    If you would like any information related to you to be removed from our systems, please send an email request to <a href="mailto:steve.depeijper@gmail.com">steve.depeijper@gmail.com</a>. 
                    We will process your request and remove all personal data associated with your account.
                  </p>
                  <br />

                  <h3>10. How can I contact you if I have questions or issues?</h3>
                  <p>
                    If you have any questions, encounter issues, or would like to provide feedback, please don't hesitate to reach out to us directly at: <a href="mailto:steve.depeijper@gmail.com">steve.depeijper@gmail.com</a>
                  </p>
                  <p>
                    We're here to help and will respond to your inquiries as quickly as possible. You can also request new features or report bugs by visiting our GitHub issues page at:
                    <HtmlContent html={content.issue_url} />
                  </p>
                  <br />

                  {/* Add navigation links */}
                  <div>
                    <NavLink to="/" className="btn btn-primary">Home</NavLink>
                    <a href="mailto:steve.depeijper@gmail.com" className="btn btn-secondary">Contact Us</a>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Faq;
